import React from "react"
import type { TypeI18n, TypeStatus } from "../../../types"
import config from "../../../config"

type TypeProps = {
  i18n: TypeI18n,
  type: "desk" | "room",
  data: TypeStatus[]
}

type TypeState = {}

class OccupancyInfo extends React.PureComponent<TypeProps, TypeState> {
  render() {
    const { data, type } = this.props

    const nbAvailable = data.filter(item => item.status === "available").length
    const nbMixed = data.filter(item => item.status === "mixed").length
    const nbBusy = data.filter(item => item.status === "busy").length

    const arrayDataColor = [
      { value: nbAvailable, color: config.theme.colors.available },
      { value: nbMixed, color: config.theme.colors.mixed },
      { value: nbBusy, color: config.theme.colors.busy }
    ]

    return (
      <div style={styles.container}>
        <div style={styles.subContainerColumn}>
          <div style={styles.containerData}>
            {data.length > 0 &&
              arrayDataColor.map((item, index, { length }) => {
                return (
                  <div style={styles.boxData}>
                    <div
                      style={
                        index === 0
                          ? styles.boxDataNumberIndex0
                          : index + 1 === length
                          ? styles.boxDataNumberIndexLast
                          : styles.boxDataNumber
                      }
                    >
                      <p
                        style={{
                          fontSize: "3vmin",
                          color: item.color,
                          margin: 0
                        }}
                      >
                        {item.value}
                      </p>
                      {item.value === 0 ? <div style={styles.opacity} /> : null}
                    </div>
                    {type === "room" ? (
                      <div
                        style={{
                          height: "5px",
                          backgroundColor:
                            item.value > 0 &&
                            index ===
                              arrayDataColor.findIndex(item => item.value > 0)
                              ? item.color
                              : config.theme.colors.occupancyStatusBarBackground
                        }}
                      />
                    ) : null}
                  </div>
                )
              })}
          </div>
          {type === "desk" ? (
            <div style={styles.colorBar}>
              {arrayDataColor.map(item => {
                return (
                  <div
                    style={{
                      backgroundColor: item.color,
                      flex:
                        item.value /
                        arrayDataColor.reduce(
                          (acc, curr) => acc + curr.value,
                          0
                        )
                    }}
                  />
                )
              })}
            </div>
          ) : null}
        </div>
      </div>
    )
  }
}

export default OccupancyInfo

const styles = {
  container: {
    flexDirection: "column",
    padding: 10,
    display: "flex",
    flex: 1
  },
  containerData: {
    backgroundColor: config.theme.colors.occupancyBackgroundContent,
    justifyContent: "center",
    flex: 1,
    display: "flex",
    flexDirection: "row"
  },
  subContainerColumn: {
    flex: 1,
    display: "flex",
    flexDirection: "column"
  },
  boxData: {
    flex: 1,
    display: "flex",
    justifyContent: "center",
    position: "relative",
    flexDirection: "column"
  },
  boxDataNumber: {
    margin: "10px 5px 10px 5px",
    flex: 1,
    display: "flex",
    backgroundColor: "#FFF",
    alignItems: "center",
    justifyContent: "center"
  },
  boxDataNumberIndex0: {
    margin: "10px 5px 10px 10px",
    flex: 1,
    display: "flex",
    backgroundColor: "#FFF",
    alignItems: "center",
    justifyContent: "center"
  },
  boxDataNumberIndexLast: {
    margin: "10px 10px 10px 5px",
    flex: 1,
    display: "flex",
    backgroundColor: "#FFF",
    alignItems: "center",
    justifyContent: "center"
  },
  poiColorBar: {
    height: 3
  },
  colorBar: {
    flexDirection: "row",
    height: 5,
    display: "flex"
  },
  containerSquareData: {
    flexDirection: "row"
  },
  squareData: {
    flex: 1,
    backgroundColor: "white",
    padding: 6,
    margin: 3,
    justifyContent: "center",
    alignItems: "center"
  },
  opacity: {
    position: "absolute",
    margin: 10,
    marginBottom: 15,
    bottom: 0,
    top: 0,
    right: 0,
    left: 0,
    backgroundColor: "#FFFFFFAA"
  }
}



// WEBPACK FOOTER //
// ./src/ui/screens/occupancy/OccupancyInfo.js